// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"18":"9441e148a9a2a056","737":"696bfbe5004a2f90","888":"6c87b837fecb3369"}[chunkId] + ".css";
};